/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Doors_TitleInputs */

const en_simple_doors_title = /** @type {(inputs: Simple_Doors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan is ready. Choose how it gets built.`)
};

const id_simple_doors_title = /** @type {(inputs: Simple_Doors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencanamu siap. Pilih cara membangunnya.`)
};

/**
* | output |
* | --- |
* | "Your plan is ready. Choose how it gets built." |
*
* @param {Simple_Doors_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_doors_title = /** @type {((inputs?: Simple_Doors_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Doors_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_doors_title(inputs)
	return en_simple_doors_title(inputs)
});